/**
 * 基础js方法的封装
 * @author huangyiustb
 * @email huangyiustb@didichuxing.com
 */

export function each(obj, fn, context) {
  if (!obj || !typeof fn === 'function') {
    return;
  }
  context = context || obj;

  if (Array.isArray(obj)) {
    for (let i = 0, l = obj.length; i < l; i++) {
      if (fn.call(context, obj[i], i, obj) === false) {
        return
      }
    }
  } else if (typeof obj === 'object') {
    for (let n in obj) {
      if (fn.call(context, obj[n], n, obj) === false) {
        return
      }
    }
  }
}

const camelizeRE = /_(\w)/g;
export function camelize (str) {
  return str.replace(camelizeRE, toUpper)
}

function toUpper (_, c) {
  return c ? c.toUpperCase() : ''
}

export function noop () {}

export function logger (params) {
  const img = new Image()
  const tmp = Date.now()

  let queryStr = ''

  if (params) {
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        queryStr += `${key}=${params[key]}&`
      }
    }
  }

  img.src = `//manhattan.activity.xiaojukeji.com/common/serverTime?${queryStr}tmp=${tmp}`
}

const invokeQueue = []
let invokeInProcess = false
const interval = 100




function _invoke() {
  const head = invokeQueue.shift()
  head.fn.apply(head, head.args)
  setTimeout(() => {
    if (invokeQueue.length) {
      _invoke()
    } else {
      invokeInProcess = false
    }
  }, interval)
}

export function invokeInTurn(fn, args) {
  invokeQueue.push({
    fn,
    args,
  })
  if (!invokeInProcess) {
    invokeInProcess = true
    _invoke()
  }
}


// WEBPACK FOOTER //
// ./src/pages/epower/bridge/util/lang.js